import { Injectable, Component } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Injectable()
export class PopupService {
    private ngbModalRef: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private router: Router,
    ) {
    }

    openComponent(component: Component, data: any) : Promise<NgbModalRef> {
        return new Promise<NgbModalRef>((resolve, reject) => {
            const isOpen = this.ngbModalRef !== null;
            if (isOpen) {
                resolve(this.ngbModalRef);
            }
            // setTimeout used as a workaround for getting ExpressionChangedAfterItHasBeenCheckedError
            setTimeout(() => {
                this.ngbModalRef = this.modalRef(component, data);
                resolve(this.ngbModalRef);
            }, 0);
        });
        // this.shopModalRef(component, data, config);
    }

    private modalRef(component: Component, data: any): NgbModalRef {
        const modalRef = this.modalService.open(component, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
            windowClass: 'popup-preview'
        });
        modalRef.componentInstance.data = data;
        
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
             this.ngbModalRef = null;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
             this.ngbModalRef = null;
        });
        return modalRef;
    }

    // private shopModalRef(component: Component, data: any, config?): NgbModalRef {
    //     const defaultModalConfig: any = {
    //         size: 'lg',
    //         backdrop: 'static'
    //     };

    //     const mergeConfig = Object.assign(defaultModalConfig, config);
    //     const modalRef = this.modalService.open(component, mergeConfig);
    //     modalRef.componentInstance.data = data;

    //     return modalRef;
    // }
}
